/**
 * Displays an icon
 *
 * Props:
 * - name: the name of the icon
 * - size: the size of the icon, it will be interpreted as the width and height
 * - color: the color of the icon
 * - style: can override the component's style
 */

import React from 'react';
import type { CSSProperties, FunctionComponent } from 'react';

import { COLORS } from 'Components/foundation';
import { ICONS, IconName } from 'Components/foundation/icons';

export type UIconProps = {
  name: IconName;
  color?: string;
  size?: number;
  style?: CSSProperties;
} & Omit<React.SVGProps<SVGSVGElement>, 'color' | 'size' | 'style'>;

export const UIcon: FunctionComponent<UIconProps> = ({
  name,
  style = undefined,
  color = COLORS.BLACK.DEFAULT,
  size = 32,
  ...props
}) => {
  const Icon = ICONS[name];

  if (!Icon) {
    return null;
  }

  return <Icon color={color} name={name} width={size} height={size} style={style} {...props} />;
};

export default UIcon;
